import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { redirectTo } from 'actions/auth';

export class RequiresAuth extends Component {
  componentDidMount() {
    this.cacheRoute();
  }

  componentDidUpdate(prevProps, prevState) {
    this.cacheRoute();
  }

  cacheRoute() {
    const { isAuthenticated, saveRedirectTo, location } = this.props;
    if (!isAuthenticated) {
      saveRedirectTo(location.pathname + location.search);
    } else {
      saveRedirectTo(null);
    }
  }

  render() {
    const { isAuthenticated } = this.props;
    return isAuthenticated ? null : <Redirect to="/login" />;
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

const mapDispatchToProps = dispatch => ({
  saveRedirectTo: path => dispatch(redirectTo(path))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RequiresAuth));
